enum HERO_SECTION {
  banner = 'banner',
  sticky = 'sticky',
  section = 'section',
}

export default HERO_SECTION;
